import React from "react";

interface IProps {
  setModalOpen: (boolean) => void;
}

const Modal = ({ setModalOpen }: IProps) => {
  return <div></div>;
};

export default Modal;
